import { render, staticRenderFns } from "./mainController.vue?vue&type=template&id=401bf3d5&scoped=true"
import script from "./mainController.vue?vue&type=script&lang=js"
export * from "./mainController.vue?vue&type=script&lang=js"
import style0 from "./mainController.vue?vue&type=style&index=0&id=401bf3d5&prod&lang=scss"
import style1 from "./mainController.vue?vue&type=style&index=1&id=401bf3d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401bf3d5",
  null
  
)

export default component.exports